import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iExistFileCheckState {
    group_name: string | null;
    library_name: string | null;
    isLoading: boolean;
    message: string | null;
    response: any[];
}


const initialState: iExistFileCheckState = {
    group_name: null,
    library_name: null,
    isLoading: false,
    message: "",
    response: [],
};

// Molecule Upload API 호출
export const existWorkSpaceCheckAPI = createAsyncThunk(
    "EXIST_FILE_CHECK",
    async (params: { group_name: string; library_name: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = `/library/exists/?group_name=${params.group_name}&name=${params.library_name}`;   
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`,  {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Molecule Upload Slice
export const existWorkSpaceCheckSlice = createSlice({
    name: "existFileCheck",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(existWorkSpaceCheckAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
            })
            .addCase(existWorkSpaceCheckAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(existWorkSpaceCheckAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    },
});
// Reducer
export default existWorkSpaceCheckSlice.reducer;